module.exports = __webpack_public_path__ + "img/SEND.180641f9.svg";